"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactSpring = require("react-spring");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _Overlay = require("../../atoms/Overlay");

var _Typography = require("../../atoms/Typography");

var _Icons = require("../../atoms/Icons");

var _Icon = require("../../atoms/Icon");

var _Layout = require("../../atoms/Layout");

var ModalContext = _react.default.createContext();

var ModalDialog = (0, _styledComponents.default)(_reactSpring.animated.div).withConfig({
  displayName: "Modal__ModalDialog",
  componentId: "sc-3xja7h-0"
})({
  position: 'fixed',
  zIndex: 9999,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexFlow: 'column wrap'
});

var ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalContainer",
  componentId: "sc-3xja7h-1"
})({
  position: 'fixed',
  zIndex: 9999,
  display: 'flex',
  flexFlow: 'column wrap',
  justifyContent: 'center',
  alignItems: 'center',
  width: function width(_ref) {
    var fullScreen = _ref.fullScreen;
    return fullScreen && '100vw';
  },
  height: function height(_ref2) {
    var fullScreen = _ref2.fullScreen;
    return fullScreen && '100vh';
  }
}, _styledSystem.border, _styledSystem.layout, _styledSystem.space, _styledSystem.color);

var CloseButton = (0, _styledComponents.default)(_Icon.Icon).withConfig({
  displayName: "Modal__CloseButton",
  componentId: "sc-3xja7h-2"
})({
  cursor: 'pointer'
});

var focusArea = function focusArea(container) {
  var focusableElements = container.querySelectorAll('button, a, input, textarea, select');
  if (focusableElements[0]) focusableElements[0].focus();
};

var Modal = function Modal(_ref3) {
  var children = _ref3.children,
      fullScreen = _ref3.fullScreen,
      isOpen = _ref3.isOpen,
      duration = _ref3.duration,
      onModalClose = _ref3.onModalClose,
      scroll = _ref3.scroll,
      id = _ref3.id,
      closeWithButton = _ref3.closeWithButton,
      props = (0, _objectWithoutProperties2.default)(_ref3, ["children", "fullScreen", "isOpen", "duration", "onModalClose", "scroll", "id", "closeWithButton"]);
  var modalRef = (0, _react.useRef)(null);
  var ESCAPE_KEY_CODE = 27;

  var closeModal = function closeModal(e) {
    e.stopPropagation();
    onModalClose();
  };

  var handleEsc = function handleEsc(e) {
    if (e.keyCode === ESCAPE_KEY_CODE) {
      closeModal(e);
    }
  };

  (0, _react.useEffect)(function () {
    modalRef.current = document.createElement('div');
  }, []);
  (0, _react.useEffect)(function () {
    modalRef.current.id = id;
    var _document = document,
        body = _document.body;
    var childrenModal = Array.from(document.querySelectorAll("body > div:not(#".concat(id, ")")));

    if (isOpen) {
      var _modalRef$current$que;

      childrenModal.forEach(function (tag) {
        tag.style.transition = "filter ".concat(duration, "ms ease-in");
        tag.style.filter = 'blur(10px)';
      });
      focusArea(modalRef.current);
      document.addEventListener('keydown', handleEsc);
      (_modalRef$current$que = modalRef.current.querySelector('#cancel-button')) === null || _modalRef$current$que === void 0 ? void 0 : _modalRef$current$que.addEventListener('click', function (e) {
        return closeModal(e);
      });
    } else {
      document.removeEventListener('keydown', handleEsc);
    }

    body.appendChild(modalRef.current);
    return function () {
      childrenModal.forEach(function (tag) {
        tag.style.transition = '';
        tag.style.filter = '';
      });
    };
  }, [isOpen]);
  var modalTransition = (0, _reactSpring.useTransition)(isOpen, null, {
    from: {
      opacity: 0
    },
    enter: {
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });
  return modalRef.current && _reactDom.default.createPortal(modalTransition.map(function (_ref4) {
    var item = _ref4.item,
        style = _ref4.props,
        key = _ref4.key;
    return item && _react.default.createElement(ModalContext.Provider, {
      key: key
    }, _react.default.createElement(ModalDialog, {
      style: style,
      duration: duration
    }, _react.default.createElement(_Overlay.Overlay, {
      onClick: closeModal
    }), _react.default.createElement(ModalContainer, (0, _extends2.default)({
      maxWidth: ['664px'],
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      fullScreen: fullScreen,
      "aria-modal": "true",
      "aria-label": "dmstk-modal",
      borderRadius: fullScreen ? 0 : 3,
      paddingY: closeWithButton ? [5, 5, 5] : [7, 7, 7],
      paddingX: [5, 5, 5],
      backgroundColor: "coco",
      marginX: [3, 3, null],
      marginY: [4, 4, null]
    }, props), closeWithButton && _react.default.createElement(_Layout.Flex, {
      alignSelf: "end",
      marginBottom: 2
    }, _react.default.createElement(CloseButton, {
      role: "button",
      fontSize: "16px",
      onClick: closeModal
    }, _react.default.createElement(_Icons.Close, null))), children)));
  }), modalRef.current);
};

exports.Modal = Modal;
Modal.defaultProps = {
  fullScreen: false,
  closeWithButton: false,
  duration: 0
};

Modal.Title = function (_ref5) {
  var children = _ref5.children;
  return _react.default.createElement(_Typography.Text, {
    as: "h4",
    size: "medium",
    fontWeight: "medium",
    marginBottom: 3,
    textAlign: "center"
  }, children);
};

Modal.Title.propTypes = {
  children: _propTypes.default.node.isRequired
};

Modal.Content = function (_ref6) {
  var children = _ref6.children;
  return _react.default.createElement(_Layout.Box, {
    marginX: 7
  }, children);
};

Modal.Content.propTypes = {
  children: _propTypes.default.node.isRequired
};

Modal.Actions = function (_ref7) {
  var children = _ref7.children;
  return _react.default.createElement(_Layout.Box, {
    marginX: 7
  }, children);
};

Modal.Actions.propTypes = {
  children: _propTypes.default.node.isRequired
};